import { Check, Phone, RotateCcw } from "lucide-react";
import { WaIcon } from "./Primitives";

const fmt = (iso) => new Date(iso).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" });
const digits = (p) => {
  const d = p.replace(/\D/g, "");
  return d.length === 10 ? `91${d}` : d;
};

const Meta = ({ k, v }) => v ? (
  <div>
    <p className="font-mono text-[9px] uppercase tracking-[0.22em] text-clay">{k}</p>
    <p className="mt-1 text-sm text-ink">{v}</p>
  </div>
) : null;

export const EnquiryCard = ({ en, onToggle }) => (
  <article data-testid={`enquiry-item-${en.id}`} className={`border p-6 transition-colors duration-300 sm:p-7 ${en.handled ? "border-ink/10 bg-sand/50 opacity-75" : "border-gold/40 bg-white/70"}`}>
    <div className="flex flex-wrap items-start justify-between gap-4">
      <div>
        <div className="flex items-center gap-3">
          <h2 className="font-display text-2xl">{en.name}</h2>
          <span data-testid={`enquiry-status-${en.id}`} className={`rounded-full px-2.5 py-0.5 font-mono text-[9px] uppercase tracking-[0.2em] ${en.handled ? "bg-ink/10 text-clay" : "bg-crimson text-parchment"}`}>{en.handled ? "Handled" : "New"}</span>
        </div>
        <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-clay">{fmt(en.created_at)}</p>
      </div>
      <button data-testid={`enquiry-toggle-${en.id}`} onClick={onToggle} className={`flex items-center gap-2 rounded-full px-4 py-2 text-xs font-semibold transition-colors duration-300 ${en.handled ? "border border-ink/20 text-ink/70 hover:border-ink/50" : "bg-crimson text-parchment hover:bg-crimson-bright"}`}>
        {en.handled ? <><RotateCcw size={13} /> Mark as new</> : <><Check size={13} /> Mark handled</>}
      </button>
    </div>
    <div className="mt-6 grid grid-cols-2 gap-5 sm:grid-cols-4">
      <Meta k="Phone" v={en.phone} />
      <Meta k="Email" v={en.email} />
      <Meta k="Category" v={en.category} />
      <Meta k="Quantity" v={en.quantity} />
      <Meta k="Delivery" v={en.city} />
    </div>
    {en.message && <p className="mt-5 whitespace-pre-line border-l-2 border-gold/50 pl-4 text-sm leading-relaxed text-ink/80">{en.message}</p>}
    <div className="mt-6 flex flex-wrap gap-3">
      <a data-testid={`enquiry-whatsapp-${en.id}`} href={`https://wa.me/${digits(en.phone)}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 rounded-full bg-wa px-4 py-2 text-xs font-semibold text-white hover:bg-wa-bright"><WaIcon className="h-3.5 w-3.5" /> WhatsApp</a>
      <a data-testid={`enquiry-call-${en.id}`} href={`tel:${en.phone}`} className="flex items-center gap-2 rounded-full border border-ink/20 px-4 py-2 text-xs font-semibold hover:border-crimson hover:text-crimson"><Phone size={13} /> Call</a>
    </div>
  </article>
);
